  <div class="dashboard">
    <p-panel header="{{ 'INICIO_DASHBOARD.LBL_WIDGETPROSPECTOSMES' | translate}}">
      <div *ngIf="!carInformacion">
        <div class="grid">
          <div class="col-12 md:col-4 md:col-offset-4">
            <div class="div-form">
              <label for="idFiltro">{{ 'INICIO_DASHBOARD.LBL_OFICINA' | translate}}</label>
              <p-dropdown disableTab  id="idFiltro" [options]="lisFiltros"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          [(ngModel)]="idFiltro" (onChange)="filtrar()"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          ></p-dropdown>
            </div>
          </div>
        </div>
        <hr>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-chart type="bar" [data]="datGrafico" [options]="opciones"></p-chart>
          </div>
        </div>
      </div>
      <div *ngIf="carInformacion" class="text-center">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_PROCESANDO' | translate }}</span>
      </div>
    </p-panel>
  </div>
